import styles from './Icons.module.scss'
import { getBaseURL } from '../../GlobalComponents/URLs'

export const EditPencil = {
    name: 'EditPencil',
    content:
        '<?xml version="1.0" encoding="UTF-8"?><svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16.01"><defs><style>.cls-1{fill:#0062FF;}</style></defs><g id="Layer_1-2"><path class="cls-1" d="m9.78,2.93c1.09,1.09,2.18,2.17,3.31,3.3-1.2,1.19-2.42,2.41-3.63,3.62-1.94,1.94-3.89,3.88-5.82,5.83-.23.23-.46.33-.79.32-.93-.02-1.86,0-2.85,0C0,14.91,0,13.86,0,12.81c0-.11.1-.23.19-.31,3.17-3.17,6.34-6.34,9.51-9.51.03-.03.07-.05.08-.05Zm5.95-.56c-.69-.72-1.39-1.42-2.11-2.11-.36-.34-.81-.35-1.15-.02-.56.53-1.09,1.09-1.59,1.59,1.11,1.11,2.19,2.2,3.29,3.3.5-.5,1.05-1.02,1.57-1.57.35-.36.34-.82-.01-1.19Z"/></g></svg>',
    viewBox: '0 0 16.59 20.32',
}

export const FilterIcon = () => {
    return <span className={styles.filterIcon} />
}
export const SearchIcon = () => {
    return <span className={styles.searchIcon} />
}
export const CheckIcon = () => {
    return <span className={styles.checkIcon} />
}
export const ReturnIcon = () => {
    return <span className={styles.returnIcon} style={{ backgroundImage: `url('${getBaseURL()}images/return.png')` }} />
}
export const InsightIcon = () => {
    return <span className={styles.insightIcon} style={{ backgroundImage: `url('${getBaseURL()}images/return.png')` }} />
}
